// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2M1Tp","title":"BackImages_title__2gWUH","images":"BackImages_images__2GAXv"};